// import { merchantStroe } from "@/stores";
import { useAuthContext } from "@/auth/useAuthContext";
import InvoiceAPI from "./InvoiceAPI";
import InvoiceWebhookAPI from "./InvoiceWebhookAPI";
import InvoiceInfo from "./InvoiceInfo";

import { CREATE_INVOCIE_API_INFO, CREATE_INVOCIE_API_URL } from "@/config";

export default function Index() {
  // const { UserInfo } = merchantStroe;
  const { user } = useAuthContext();
  let check: boolean = [1, 2, 8].includes(user?.role_id || 0);
  let INVOICE_CREATE_ = check ? CREATE_INVOCIE_API_URL : "***";
  let CREATE_INVOCIE_API_INFO_ = check ? CREATE_INVOCIE_API_INFO : "***";

  return (
    <>
      <InvoiceAPI url={INVOICE_CREATE_} />
      <InvoiceWebhookAPI />
      <InvoiceInfo url={CREATE_INVOCIE_API_INFO_} />
    </>
  );
}
